import worktual_logo from './images/worktual_logo.svg';
import notify_icon from './images/notify_icon.svg';
import help_icon from './images/help_icon.svg';
import chevrondown_icon from './navigationImages/chevrondown.svg';
import search_icon from './images/search_icon.svg';
import aws_icon from './connectorsImages/aws.svg';
import bigquery_icon from './connectorsImages/bigquery.svg';
import facebook_icon from './connectorsImages/facebook.svg';
import hubspot_icon from './connectorsImages/hubspot.svg';
import magento_icon from './connectorsImages/magento.svg';
import redshift_icon from './connectorsImages/redshift.svg';
import salesforce_icon from './connectorsImages/salesforce.svg';
import shopify_icon from './connectorsImages/shopify.svg';
import snowflake_icon from './connectorsImages/snowflake.svg';
import twilio_icon from './connectorsImages/twilio.svg';
import pluscircle from './images/plus_circle.svg';
import rightchevron from './images/rightchevron.svg';
import fivestar from "./csat_images/stargroup.svg"
import emojigrpthree from "./csat_images/emojigroup_three.svg"
import emojigrptwo from "./csat_images/emojigroup_two.svg"
import numbergrp from "./csat_images/numbergroup.svg"
import emojigrp from "./csat_images/emojigroup.svg"
import likdislike from "./csat_images/likedislike.svg"
import likewithblock from "./csat_images/likewithemoji_three.svg"
import tick_icon from './images/tick_icon.svg';
import emptysms from "./images/emptystatesmsconfig.svg"
import emptywapp from "./images/emptystatewappconfig.svg"
import uploadcloud_icon from './images/uploadcloud_icon.svg';
import camera_front from './mobile_images/camerafront.svg';
import message_bar from './mobile_images/messagebar.svg';
import mobile_topbar from './mobile_images/topbar.svg';
import avatarimg from './mobile_images/avatarimg.svg';
import google_icon from './images/google_icon.svg';
import microsoft_icon from './images/microsoft_icon.svg';
import apple_icon from './images/apple_icon.svg';
import multi_close from './images/multi_close.svg';
import sendarrow from './images/sendarrow.svg';
import rightarrow_exchange from './images/rightarrow_exchange.svg';
import fullscreen_icon from './images/fullscreen_icon.svg';
import notify_logo from './mobile_images/notification_logo.svg';
import apppush_icon from './images/notify_blueicon.svg';
import email_icon from './images/email_icon.svg';
import whatsapp_icon from './images/whatsapp_icon.svg';
import profile_sample from './images/profile_sample.jpg';

import historyicn from "./images/historyicon.svg"
import expandicn from "./images/expandicon.svg"
import Left_iconinfo from "./images/infoicon.svg"
import add_icon from './images/add_icon.svg';
import record_icon from './images/record_icon.svg';
import history_icon from './images/history_icon.svg';
import close_icon from './images/close_icon.svg';
import aiexpand_icon from './images/ai_expand_icon.svg';
import replay_logo from './images/replay_logo.svg';
import aichat_icon from './images/aichat_icon.svg';
import Magic_icon from './images/magicicon.svg';
import Send_icon from './images/sendicon.svg';
import Sendprof_icon from '../assets/images/contactimagecvm.png';
import Worktualmain_icon from '../assets/images/worktual.svg';

// leftnav assests
import aipilot_inactive from './navigationImages/aipilot_inactive.svg';
import aipilot_active from './navigationImages/aipilot_active.svg';
import customerprofile_inactive from './navigationImages/customerprofiles_inactive.svg';
import customerprofile_active from './navigationImages/customerprofiles_active.svg';
import reports_inactive from './navigationImages/reports_inactive.svg';
import reports_active from './navigationImages/reports_active.svg';
import setting_inactive from './navigationImages/settings_inactive.svg';
import setting_active from './navigationImages/settings_active.svg';
import campaing_inactive from './navigationImages/campaing_inactive.svg';
import campaign_active from './navigationImages/campaing_active.svg';
import purchase_list1 from './customerprofileimages/list1.svg';
import purchase_list2 from './customerprofileimages/list2.svg';
import purchase_list3 from './customerprofileimages/list3.svg';
import purchase_list4 from './customerprofileimages/list4.svg';
import Mail_receive from './customerprofileimages/mailsent.svg';
import Cart_list from './customerprofileimages/cartlist.svg';
import Worktualeg_logo from './images/worktualchaticon.svg';
import Chevron_icon from './images/chevron.svg';
import Mainlogo from './images/mainlogo.svg';

// quick actions
import quickaction_1 from './navigationImages/quickaction_1.svg';
import quickaction_2 from './navigationImages/quickaction_2.svg';

export const assets = {
    worktual_logo,
    expandicn,
    historyicn,
    google_icon,
    apple_icon,
    microsoft_icon,
    likewithblock,
    notify_icon,
    help_icon,
    search_icon,
    twilio_icon,
    snowflake_icon,
    shopify_icon,
    salesforce_icon,
    redshift_icon,
    magento_icon,
    aws_icon,
    bigquery_icon,
    facebook_icon,
    hubspot_icon,
    pluscircle,
    emptysms,
    emptywapp,
    rightchevron,
    fivestar,
    emojigrp,
    numbergrp,
    emojigrptwo,
    emojigrpthree,
    likdislike,
    tick_icon,
    uploadcloud_icon,
    camera_front,
    message_bar,
    mobile_topbar,
    avatarimg,
    chevrondown_icon,
    multi_close,
    sendarrow,
    rightarrow_exchange,
    fullscreen_icon,
    notify_logo,
    apppush_icon,
    email_icon,
    whatsapp_icon,
    profile_sample,Left_iconinfo,
    history_icon,
    record_icon,
    add_icon,
    close_icon,
    aiexpand_icon,
    replay_logo,
    aichat_icon,
    Magic_icon,
    Worktualeg_logo,
    Send_icon,
    Chevron_icon,
    Sendprof_icon,
    Mainlogo,
    Worktualmain_icon,
}

export const leftnavassets = {
    chevrondown_icon,
    aipilot_inactive,
    aipilot_active,
    customerprofile_inactive,
    customerprofile_active,
    reports_inactive,
    reports_active,
    setting_inactive,
    setting_active,
    quickaction_1,
    quickaction_2,
    purchase_list1,
    purchase_list2,
    purchase_list3,
    purchase_list4,
    Mail_receive,
    Cart_list,
    campaing_inactive,
    campaign_active
}